import { registerMicroApps, start, addGlobalUncaughtErrorHandler } from "qiankun"
import { subApp } from "./setting"
import store from "../src/store"

registerMicroApps([
  {
    name: 'fenxiaoExtend',
    entry: `${subApp}`,
    container: '#fenxiao_extend_container',
    activeRule: '/#/fenxiaoExtend',
    props: {
      getGlobalState: store.state.user
    }
  },
  {
    name: 'fenxiaoExtendAdvance',
    entry: `${subApp}`,
    container: '#fenxiao_extend_container',
    activeRule: '/#/fenxiaoExtendAdvance',
    props: {
      getGlobalState: store.state.user
    }
  },
  {
    name: 'fenxiaoExtendInvoice',
    entry: `${subApp}`,
    container: '#fenxiao_extend_container',
    activeRule: '/#/finaceAduit/inovice',
    props: {
      getGlobalState: store.state.user
    }
  }
], {
  beforeLoad: () => {
    console.log('子应用加载前');
  },
  beforeMount: () => {
    console.log('子应用挂载前');
  },
  afterMount: () => {
    console.log('子应用挂载后');
  },
  beforeUnmount: () => {
    console.log('子应用销毁前');
  },
  afterUnmount: () => {
    console.log('子应用销毁后');
  }
}, {
  fetch: window.fetch
})


addGlobalUncaughtErrorHandler((event) => console.log(event));

